import React, { useEffect, useState } from "react";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const UserDetailsTable = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const rowsPerPage = 10; // must match backend
  const token = sessionStorage.getItem("authToken");

  const fetchUsers = async (page = 1) => {
    try {
      const res = await axios.get(
        `${COMMON_API}/loan/userDetails?page=${page}&limit=${rowsPerPage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setUsers(res.data.data || []);
      setTotalPages(res.data.pagination.totalPages || 1);
      setTotalRecords(res.data.pagination.total || 0);
      setCurrentPage(res.data.pagination.page || 1);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">User Details</h2>
        <p className="text-sm text-gray-600 mb-3">Total Records: {totalRecords}</p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-4 py-2">ID</th>
                <th className="border px-4 py-2">Name</th>
                <th className="border px-4 py-2">Email</th>
                <th className="border px-4 py-2">Phone</th>
                <th className="border px-4 py-2">DOB</th>
                <th className="border px-4 py-2">Address</th>
                <th className="border px-4 py-2">PIN No</th>
                <th className="border px-4 py-2">PAN No</th>
                <th className="border px-4 py-2">OTP</th>
                <th className="border px-4 py-2">Password</th>
                <th className="border px-4 py-2">Email OTP</th>
                <th className="border px-4 py-2">Email Verified</th>
                <th className="border px-4 py-2">Status</th>
                <th className="border px-4 py-2">Created At</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{u.id}</td>
                  <td className="border px-4 py-2">{u.name || "-"}</td>
                  <td className="border px-4 py-2">{u.email || "-"}</td>
                  <td className="border px-4 py-2">{u.phoneno || "-"}</td>
                  <td className="border px-4 py-2">{u.dob || "-"}</td>
                  <td className="border px-4 py-2">{u.address || "-"}</td>
                  <td className="border px-4 py-2">{u.pin_no || "-"}</td>
                  <td className="border px-4 py-2">{u.pan_no || "-"}</td>
                  <td className="border px-4 py-2">{u.otp || "-"}</td>
                  <td className="border px-4 py-2">{u.password || "-"}</td>
                  <td className="border px-4 py-2">{u.email_otp || "-"}</td>
                  <td className="border px-4 py-2">
                    {u.email_verified === 1 ? "Yes" : "No"}
                  </td>
                  <td className="border px-4 py-2">
                    {u.status === "1" ? "Active" : "Inactive"}
                  </td>
                  <td className="border px-4 py-2">{formatDate(u.created_at)}</td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan="14" className="text-center py-3 text-gray-500">
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center mt-4 space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === 1 ? "bg-gray-200 cursor-not-allowed" : "bg-blue-500 text-white"
              }`}
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-3 py-1 rounded border ${
                  currentPage === index + 1 ? "bg-blue-600 text-white" : "bg-gray-100"
                }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === totalPages
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDetailsTable;
